/**
 * EditProfilePage — standalone page for /editProfile route.
 * Mirrors Flutter routing where /editProfile navigates to WebProfile
 * with profileTabIndex=0.
 *
 * This page simply redirects to /profile since the Edit Profile section
 * is a tab within the Profile page (matching Flutter behavior).
 */
import { Navigate } from 'react-router-dom';
import { ROUTES } from '@/app/router/routes';

export function EditProfilePage() {
  return <Navigate to={ROUTES.PROFILE} replace />;
}
